var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-tab"},_vm._l((_vm.tabData),function(item,index){return _c('li',{key:index,class:{'active':_vm.activeIndex == index},on:{"click":function($event){_vm.choose(index)}}},[_vm._v(_vm._s(item))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d56bede","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myTab.vue
// module id = null
// module chunks = 